import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './stories.module.scss';
import './stories.scss';

export interface IStoriesProps {
    image: string;
    title: string;
    description: any;
    btnTitle: string;
    redirect: string;
    cardsList: [
        {
            image: string;
            title: string;
            description: any;
            bgColor: string;
            textColor: string;
            redirect: string;
            btnTitle: string;
        },
    ];
}

const Stories = ({
    image,
    title,
    description,
    btnTitle,
    redirect,
    cardsList,
}: IStoriesProps) => {
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <Container component="div" className={`${styles.o_stories} o_stories`}>
            <CardMedia
                component="img"
                className={styles.o_stories__header}
                image={image}
                alt={title}
            />
            <Container component="div" className={styles.o_stories__container}>
                <Grid container spacing={3}>
                    <Grid
                        item
                        xs={12}
                        sm={4}
                        className={styles.o_stories__card}
                    >
                        <Card className={styles.o_stories__main}>
                            <CardContent>
                                <Typography
                                    variant="h2"
                                    component="div"
                                    className={styles.o_stories__h2}
                                >
                                    {title}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    className={styles.o_stories__desc}
                                >
                                    {description}
                                </Typography>
                            </CardContent>
                            <CardActions className={styles.o_stories__cta}>
                                <Button
                                    component="a"
                                    size="small"
                                    href={redirect}
                                    className={styles.o_stories__btn}
                                >
                                    {btnTitle}
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={8}
                        className={styles.o_stories__card}
                    >
                        <Slider
                            {...settings}
                            className={styles.o_stories__slider}
                        >
                            {cardsList.map((card, key) => (
                                <Card
                                    key={key}
                                    className={styles.o_stories__slide}
                                >
                                    <div
                                        className={
                                            styles.o_stories__slideContainer
                                        }
                                        style={{
                                            color: card.textColor
                                                ? card.textColor
                                                : 'black',
                                            backgroundColor: card.bgColor,
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={card.image}
                                            alt={card.title}
                                            className={styles.o_stories__img}
                                        />
                                        <CardContent className={styles.o_stories__info}>
                                            <Typography
                                                variant="h3"
                                                component="div"
                                                className={styles.o_stories__h3}
                                            >
                                                {card.title}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                component="p"
                                                className={
                                                    styles.o_stories__desc
                                                }
                                            >
                                                {card.description}
                                            </Typography>
                                            <CardActions
                                                className={
                                                    styles.o_stories__actions
                                                }
                                            >
                                                <Button
                                                    component="a"
                                                    size="small"
                                                    href={redirect}
                                                    className={
                                                        styles.o_stories__link
                                                    }
                                                >
                                                    {card.btnTitle}
                                                </Button>
                                            </CardActions>
                                        </CardContent>
                                    </div>
                                </Card>
                            ))}
                        </Slider>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    );
};

export default Stories;
